module.exports = __webpack_public_path__ + "media/audio.8c7102fc.mp3";